import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/home/Home.vue';
import Followup from '../views/followup/Followup.vue';
import FollowupForShare from '../views/followup/FollowupForShare.vue';
import Result from '../views/followup/Result.vue';
import ResultForShare from '../views/followup/ResultForShare.vue';
import Content from '../views/followup/Content.vue';
import Faq from '../views/faq/Faq.vue';
import FaqContent from '../views/faq/FaqContent.vue';
import Questions from '../views/faq/Questions.vue';
import NotFound from '../views/404.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/followup',
        name: 'Followup',
        component: Followup,
        children: [
            {
                path: 'result',
                name: 'Result',
                component: Result
            },
            {
                path: '',
                name: 'Content',
                component: Content
            },
        ]
    },
    {
        path: '/followupForShare',
        name: 'FollowupForShare',
        component: FollowupForShare,
        children: [
            {
                path: 'resultForShare',
                name: 'ResultForShare',
                component: ResultForShare
            },
            {
                path: '',
                name: 'Content',
                component: Content
            },
        ]
    },
    {
        path: '/faq',
        name: 'Faq',
        component: Faq,
        children: [
            {
                path: 'questions/:index',
                name: 'Questions',
                component: Questions
            },
            {
                path: '',
                name: 'FaqContent',
                component: FaqContent
            },
        ]
    },
    {
        path: '/404',
        name: 'NotFound',
        component: NotFound,
    },
    {
        path: '*',
        redirect: '/404',
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
    routes
});

export default router;
